import { useMemo } from 'react'
import { type ProductOfferWithDeductible } from '@/features/priceCalculator/PurchaseForm/OfferPresenter/DeductibleSelector'
import { type ProductOfferWithInsuranceAmount } from '@/features/priceCalculator/PurchaseForm/OfferPresenter/InsuranceAmountSelector'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { getSortedOffers } from '@/utils/offers.utils'

type Params = {
  offers: Array<ProductOfferFragment>
  selectedOffer: ProductOfferFragment
}

export function useOfferVariants({ offers, selectedOffer }: Params) {
  return useMemo(() => {
    const sortedOffers = getSortedOffers(offers)

    const tiers: Array<ProductOfferFragment> = []

    const usedTiers = new Set<string>()

    for (const offer of sortedOffers) {
      const variantTier = offer.variant.typeOfContract

      if (usedTiers.has(variantTier)) continue

      usedTiers.add(variantTier)

      tiers.push(variantTier === selectedOffer.variant.typeOfContract ? selectedOffer : offer)
    }

    const deductibles = sortedOffers.filter(
      (item): item is ProductOfferWithDeductible =>
        item.deductible != null && item.variant.typeOfContract === selectedOffer.variant.typeOfContract,
    )

    const insuranceAmounts = sortedOffers.filter(
      (item): item is ProductOfferWithInsuranceAmount =>
        item.insuranceAmount != null && item.variant.typeOfContract === selectedOffer.variant.typeOfContract,
    )

    return { tiers, deductibles, insuranceAmounts }
  }, [offers, selectedOffer])
}
